



















import { Prop, Vue } from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import Component from 'vue-class-component';
import { Invoice } from '@/store/types/work/invoice';
import WorkHttp from '@/http/WorkHttp';

@Component({
  components: { Dialog }
})
export default class AddDiscount extends Vue {
  @Prop() showDialog!: boolean;
  @Prop() outgoing!: boolean;
  @Prop() invoice!: Invoice;

  protected params = {
    value: 10
  };

  public save () {
    (new WorkHttp(this.invoice.from_enterprise_id)).post({
      url: `/invoices/outgoing/${this.invoice.id}/set-discount`,
      data: this.params
    }).then(res => {
      this.$emit('save');
    }).catch(e => {
      alert('Сталась помилка під час заповнення форми. Перевірте коректність');
    });
  }

  get priceAfterDiscount () {
    return this.invoice.cash * ((100 - this.params.value) / 100);
  }
}
